import { Component, OnInit, inject, ChangeDetectorRef } from '@angular/core';
import { TnbUser } from '../../service/auth/tnb-user';
import { DatenabfrageService } from '../../service/datenabfrage/datenabfrage.service';
import { Observable } from 'rxjs/internal/Observable';
import { TeilgebietSelectionService } from '../../service/common/teilgebiet/teilgebiet-selection.service';
import { AuthenticationService } from '../../service/auth/authentication.service';
import { ActivatedRoute } from '@angular/router';
import { Aufteilungsschluessel } from '../../domain/model/datenabfrage/aufteilungsschluessel';
import { Datenabfrage } from '../../domain/model/datenabfrage/datenabfrage';
import { combineLatest, of } from 'rxjs';
import { ArchivierteDatenabfrage } from '../../domain/model/datenabfrage/archivierte-datenabfrage';
import { NetzbetreiberAktiveDatenabfrageAssignment } from '../../domain/model/datenabfrage/netzbetreiber-aktive-datenabfrage-assignment';

@Component({
    selector: 'tnb-datenabfrage-page',
    templateUrl: './datenabfrage-page.component.html',
    styleUrls: [
        './datenabfrage-page.component.scss',
    ],
    standalone: false,
})
export class DatenabfragePageComponent implements OnInit {
    private route = inject(ActivatedRoute);
    private datenabfrageService = inject(DatenabfrageService);
    private teilgebieteSelectionService = inject(TeilgebietSelectionService);
    private authenticationService = inject(AuthenticationService);
    private changeDetectorRef = inject(ChangeDetectorRef);

    public allDatenAbfrageDataCombined$: Observable<any>;
    public aktiveDatenabfrage: Datenabfrage;

    public archivierteDatenabfragen: ArchivierteDatenabfrage[] = [];

    public aufteilungsSchluessels$: Observable<Aufteilungsschluessel[] | []>;
    public assignedNetzbetreiber: NetzbetreiberAktiveDatenabfrageAssignment[];
    public notAssignedNetzbetreiber: NetzbetreiberAktiveDatenabfrageAssignment[];

    private readonly tnbUser: TnbUser;
    isWestnetzAdmin = false;
    isWestnetzUser = false;
    isStadtwerk = false;
    isNvnbAssignedToAktiveDf = false;

    constructor() {
        this.tnbUser = this.route.snapshot.data.profile;
        this.isWestnetzAdmin = this.authenticationService.isWestnetzAdmin(this.tnbUser);
        this.isWestnetzUser = this.authenticationService.isWestnetzUser(this.tnbUser);
        this.isStadtwerk = this.authenticationService.isNvnb(this.tnbUser);
    }

    ngOnInit(): void {
        let aktiveDatenabfrage$: Observable<Datenabfrage> = this.datenabfrageService.getAktiveDatenAbfrage(
            this.authenticationService.isWestnetzUserOrWestnetzAdmin(this.tnbUser),
            this.teilgebieteSelectionService.getSelectedStadtwerkeId(),
        );
        let archivierteDatenabfragen$: Observable<ArchivierteDatenabfrage[] | null> = this.datenabfrageService.getArchivierteDatenabfragen(
            this.authenticationService.isWestnetzUserOrWestnetzAdmin(this.tnbUser),
            this.teilgebieteSelectionService.getSelectedStadtwerkeId(),
        );
        let netzbetreibersWithAssignmentsToAktiveDatenAbfrage$:
            Observable<NetzbetreiberAktiveDatenabfrageAssignment[] | null> =
            (this.isWestnetzAdmin || this.isWestnetzUser) ?
                this.datenabfrageService.getNetzbetreibersWithAssignmentsToAktiveDatenAbfrage() :
                of([]);

        this.allDatenAbfrageDataCombined$ = combineLatest([
            aktiveDatenabfrage$,
            archivierteDatenabfragen$,
            netzbetreibersWithAssignmentsToAktiveDatenAbfrage$,
        ]);
        this.refresh();
    }

    refresh() {
        this.allDatenAbfrageDataCombined$.subscribe(([
            aktiveDatenabfrage,
            archivierteDatenabfrage,
            netzbetreiberAktiveDatenabfrageAssignments,
        ]) => {
            if (aktiveDatenabfrage != null && aktiveDatenabfrage.id !== undefined) {
                this.aktiveDatenabfrage = aktiveDatenabfrage;
                this.aufteilungsSchluessels$ =
                    this.datenabfrageService.getAufteilungsschluessel(aktiveDatenabfrage.id, this.teilgebieteSelectionService.getSelectedStadtwerkeId());
                if (this.isStadtwerk) {
                    this.isNvnbAssignedToAktiveDf = this.aktiveDatenabfrage.zugeordneteNetzbetreiber.find(it =>
                        it.stadtwerkeId == this.teilgebieteSelectionService.getSelectedStadtwerkeId()) != undefined;
                }
            } else {
                this.aktiveDatenabfrage = null;
            }
            this.archivierteDatenabfragen = archivierteDatenabfrage;
            this.assignedNetzbetreiber = netzbetreiberAktiveDatenabfrageAssignments.filter(nb => nb.teilnehmerAktiveDatenAbfrage === true);
            this.notAssignedNetzbetreiber = netzbetreiberAktiveDatenabfrageAssignments.filter(nb => nb.teilnehmerAktiveDatenAbfrage === false);
            this.changeDetectorRef.markForCheck();
        });
    }
}
